import {
  createRouter,
  createWebHashHistory,
} from 'vue-router';
// import HomeView from '../views/HomeView.vue'
import store from '@/store';
import { useMessage } from '@/hooks/useMessage';
// 导入进度条插件
import useNProgress from '@/hooks/useNProgress';
const NProgress = useNProgress();

// 页面布局组件
const Layout_mw = () =>
  import(/* webpackChunkName: "layout" */ '@/layout/des_mw.vue');
const Layout_mecs = () =>
  import(/* webpackChunkName: "layout" */ '@/layout/mecs.vue');
const Layout_admin = () =>
  import(/* webpackChunkName: "layout" */ '@/layout/admin.vue');

// 对于权限管理，刚开始路由只加载，不需要权限的路由、比如：登录、404、这些无关紧要的路由
// 对于这些需要权限的路由，我们需要根据后台返回的权限路由，通过router.addRoute()动态添加进来
const routes = [
// 默认 / 由路由守卫处理，登录后根据角色导航到对应页面
  // layout admin 系统管理后台（超级管理员专属）
  {
    path: '/admin',
    name: 'layout_admin',
    component: Layout_admin,
    redirect: '/admin/platform',
    children: [],
  },
  // layout des_mw  数字化能源管理平台DEMP
  {
    path: '/des_mw/project',
    name: 'layout_mw',
    component: Layout_mw,
    redirect: '/des_mw/project/map',
    children: [],
  },
  // layout des_mw 系统管理
  {
    path: '/des_mw/system',
    name: 'layout_mw_system',
    component: Layout_mw,
    redirect: '/des_mw/system/user',
    children: [],
  },
  // 系统管理（公共路由，超级管理员在各平台均可访问）
  {
    path: '/system',
    name: 'layout_system',
    component: Layout_mw,
    redirect: '/system/user',
    children: [],
  },
  {
    path: '/des_mw',
    name: 'des_mw',
    component: () => import('@/views/mw_views/projectList.vue'),
  },
  // layout  MECS
  {
    path: '/mecs/project',
    name: 'layout_mecs',
    component: Layout_mecs,
    redirect: '/mecs/project/map',
    children: [],
  },
  // layout  MECS 系统管理
  {
    path: '/mecs/system',
    name: 'layout_mecs_system',
    component: Layout_mecs,
    redirect: '/mecs/system/user',
    children: [],
  },
  {
    path: '/mecs',
    name: 'mecs',
    component: () => import('@/views/mecs_views/projectList.vue'),
  },
  // DES-TES 平台：业务未开发，平台下**所有**子路径一律回落平台入口 /#/des_tes
  // （原来是 /des_tes/project|system 两个 layout 壳 + 动态注册的子路由，子路由全部指向
  //  @/views/mw_views/** 的真实页面 —— 直接输 URL 会看到一个可用的能源管理页面，
  //  而没有任何"开发中"提示。拍板：子路由删除，直接输地址统一回落。）
  // 平台入口本身（下列 /des_tes）是 tes_views/projectList.vue，点 TYPE=3 项目已提示「暂未开放」。
  {
    path: '/des_tes/:pathMatch(.*)*',
    redirect: '/des_tes',
  },
  {
    path: '/des_tes',
    name: 'des_tes',
    component: () => import('@/views/tes_views/projectList.vue'),
  },
  // 所有软件平台platform - 重定向到管理后台的平台总览
  {
    path: '/platform',
    redirect: '/admin/platform',
  },
  // 帮助中心（独立页面，不在项目路由中）
  {
    path: '/help',
    name: 'help',
    component: () => import('@/views/help/help.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/Login.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Login/Register.vue'),
  },
  // Error
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import('@/views/Error/404.vue'),
  },
];
// 创建路由
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

/**
 * 用户登录后的"落地页"：超管 → 管理后台；否则按其第一个项目类型进对应平台；都没有 → 登录页。
 * 供"无权访问"回退使用（守卫里另有两处等价的内联判断，属历史写法，未一并重构以免改行为）。
 */
const landingOf = () => {
  const roles = store.state.user.userInfo.roles || [];
  const isSysAdmin = roles.some(
    (r) => r.role_key === '1001' || r.role_key === 'sys_admin'
  );
  if (isSysAdmin) return { path: '/admin/platform', replace: true };
  const projects = store.state.user.userInfo.projects || [];
  if (!projects.length) return { path: '/login', replace: true };
  const pt = projects[0].project_type;
  if (pt === 1) return { path: '/mecs', replace: true };
  if (pt === 2) return { path: '/des_mw', replace: true };
  if (pt === 3) return { path: '/des_tes', replace: true };
  return null;
};

// 全局导航前置守卫
router.beforeEach((to, from, next) => {
  // 开启进度条动画
  NProgress.start();
  // 启动时加载系统 Logo（只请求一次，后续由 localStorage 缓存）
  if (!store.state.layout.logoUrl) {
    store.dispatch('layout/fetchLogo');
  }
  const token = store.state.user.token;
  if (to.name !== 'login' && to.name !== 'register') {
    if (!token) {
      // 返回到登录页
      next({ name: 'login' });
    } else {
      // 页面刷新，重新加载权限路由
      if (!store.state.user.isDynamicAddedRoute) {
        store.dispatch('user/loadAsyncRoute').then(() => {
          // 加载完路由后，处理根路径重定向
          if (to.path === '/' || to.path === '') {
            const roles = store.state.user.userInfo.roles || [];
            const isSysAdmin = roles.some(r => r.role_key === '1001' || r.role_key === 'sys_admin');
            const projects = store.state.user.userInfo.projects || [];
            if (isSysAdmin) {
              next({ path: '/admin/platform', replace: true });
            } else if (projects.length > 0) {
              const pt = projects[0].project_type;
              if (pt === 1) next({ path: '/mecs', replace: true });
              else if (pt === 2) next({ path: '/des_mw', replace: true });
              else if (pt === 3) next({ path: '/des_tes', replace: true });
              else next(to.fullPath);
            } else {
              next({ path: '/login', replace: true });
            }
          } else {
            // 直接导航到目标路径
            next(to.fullPath);
          }
        });
      } else {
        // 根路径已经加载过路由，根据角色重定向
        if (to.path === '/' || to.path === '') {
          const roles = store.state.user.userInfo.roles || [];
          const isSysAdmin = roles.some(r => r.role_key === '1001' || r.role_key === 'sys_admin');
          const projects = store.state.user.userInfo.projects || [];
          if (isSysAdmin) return next({ path: '/admin/platform', replace: true });
          else if (projects.length > 0) {
            const pt = projects[0].project_type;
            if (pt === 1) return next({ path: '/mecs', replace: true });
            else if (pt === 2) return next({ path: '/des_mw', replace: true });
            else if (pt === 3) return next({ path: '/des_tes', replace: true });
          }
          return next({ path: '/login', replace: true });
        }
        // 判断是否进入项目详情页（需携带正确参数）
        if (to.path.includes('/mecs/project') || to.path.includes('/des_mw/project')) {
          if (!store.state.project.chooseProject.PROJECT_ID) {
            useMessage('请选择项目', 'warning');
            if (to.path.includes('/mecs')) return next({ name: 'mecs' });
            if (to.path.includes('/des_mw')) return next({ name: 'des_mw' });
          }
        }
        // 系统管理后台权限校验：仅超级管理员可访问
        if (to.path.startsWith('/admin')) {
          const isSysAdmin = store.state.user.userInfo?.is_sys_admin === true;
          if (!isSysAdmin) {
            useMessage('无权访问系统管理后台', 'error');
            return next({ path: '/', replace: true });
          }
        }
        // 落到 404 兜底 ≠ 页面不存在：受控路由被权限过滤掉时同样落到这里。
        // 例：guest(123) 的菜单里没有 /mecs/project/2d-editor，该路由从未注册，
        // 直接输地址会看到「抱歉，您访问的页面不存在」—— 把权限问题说成了路径问题。
        // 凡"本应用定义过该绝对路径"的，一律按无权限处理并给明确提示。
        if (
          to.name === 'notFound' &&
          (store.state.user.allRoutePaths || []).includes(to.path)
        ) {
          useMessage('无权访问该页面', 'error');
          return next(landingOf() || { path: '/', replace: true });
        }
        next();
      }
    }
  } else {
    next();
  }
});

// 全局导航后置守卫
router.afterEach(() => {
  // 关闭进度条
  NProgress.done();
});

export default router;
